export default __webpack_public_path__ + "static/media/GreenCityBlock.85ba6d6f.mp4";